import { IFormBuilderForm } from "../model/formBuilderForm";
import { applyAddEntityChange, getAddEntityInverseAction, IAddEntityAction } from "./actions/addEntity";
import { applyDeleteEntityChange, getDeleteEntityInverseAction, IDeleteEntityAction } from "./actions/deleteEntity";
import { applyMoveItemChange, getMoveItemInverseAction, IMoveItemAction } from "./actions/moveItem";
import { applyMoveRowChange, getMoveRowInverseAction, IMoveRowAction } from "./actions/moveRow";
import { IRedoAction } from "./actions/redo";
import { ISelectEntityAction } from "./actions/selectEntity";
import { IUndoAction } from "./actions/undo";
import {
  applyUpdateFormSettingsChange,
  getUpdateFormSettingsInverseAction,
  IUpdateFormSettingsAction,
} from "./actions/updateFormSettings";
import {
  applyUpdateItemSettingsChange,
  getUpdateItemSettingsInverseAction,
  IUpdateItemSettingsAction,
} from "./actions/updateItemSettings";
import { IUpdateOverlayTargetAction } from "./actions/updateOverlayTarget";
import {
  applyUpdateRowSettingsChange,
  getUpdateRowSettingsInverseAction,
  IUpdateRowSettingsAction,
} from "./actions/updateRowSettings";
import { IUpdateSelectedEntityAction } from "./actions/updateSelectedEntity";

type TFormBuilderControllerSystemAction =
  | ISelectEntityAction
  | IUpdateOverlayTargetAction
  | IUpdateSelectedEntityAction;

export type TFormBuilderControllerHistoryAction =
  | IUndoAction
  | IRedoAction
  | IAddEntityAction
  | IDeleteEntityAction
  | IMoveItemAction
  | IMoveRowAction
  | IUpdateFormSettingsAction
  | IUpdateItemSettingsAction
  | IUpdateRowSettingsAction;

export type TFormBuilderControllerAction = TFormBuilderControllerSystemAction | TFormBuilderControllerHistoryAction;

export function applyHistoryChange(
  form: IFormBuilderForm,
  action: TFormBuilderControllerHistoryAction,
): IFormBuilderForm {
  switch (action.type) {
    case "ADD_ENTITY":
      return applyAddEntityChange(form, action);
    case "DELETE_ENTITY":
      return applyDeleteEntityChange(form, action);
    case "MOVE_ITEM":
      return applyMoveItemChange(form, action);
    case "MOVE_ROW":
      return applyMoveRowChange(form, action);
    case "UPDATE_FORM_SETTINGS":
      return applyUpdateFormSettingsChange(form, action);
    case "UPDATE_ITEM_SETTINGS":
      return applyUpdateItemSettingsChange(form, action);
    case "UPDATE_ROW_SETTINGS":
      return applyUpdateRowSettingsChange(form, action);
    default:
      return form;
  }
}

export function getInverseHistoryAction(action: TFormBuilderControllerHistoryAction): TFormBuilderControllerHistoryAction {
  switch (action.type) {
    case "ADD_ENTITY":
      return getAddEntityInverseAction(action);
    case "DELETE_ENTITY":
      return getDeleteEntityInverseAction(action);
    case "MOVE_ITEM":
      return getMoveItemInverseAction(action);
    case "MOVE_ROW":
      return getMoveRowInverseAction(action);
    case "UPDATE_FORM_SETTINGS":
      return getUpdateFormSettingsInverseAction(action);
    case "UPDATE_ITEM_SETTINGS":
      return getUpdateItemSettingsInverseAction(action);
    case "UPDATE_ROW_SETTINGS":
      return getUpdateRowSettingsInverseAction(action);
    default:
      return null;
  }
}

export function applyUndoHistoryChange(
  form: IFormBuilderForm,
  action: TFormBuilderControllerHistoryAction,
): IFormBuilderForm {
  const inverseAction = getInverseHistoryAction(action);

  if (inverseAction) {
    return applyHistoryChange(form, inverseAction);
  } else {
    return form;
  }
}